module.exports = __webpack_public_path__ + "img/interviewPrepModal.79076737.svg";